import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://jhlxvhlsrhwkizgclcox.supabase.co";
const supabaseKey = "sb_publishable_YBECKsprcAneoZMrcopNKg_qMOdDeO6";

export const supabase = createClient(supabaseUrl, supabaseKey);